<template>
    <div class="modal fixed" v-if="show">
        <div :class="modalClass">
            <button v-if="back" class="close absolute pt-3 md:fixed md:left-auto z-10" @click="close()">
                <icon icon="chevron-left"></icon>
            </button>

            <slot>

            </slot>
        </div>
    </div>
</template>

<style>
    .close {
        padding: 10px;
        font-size: 30px;
        @apply px-3 py-0 text-right;
        cursor: pointer;
    }

    .modal {
        @apply fixed top-0 left-0 bg-black w-full h-full flex overflow-hidden;
        background-color:rgba(0, 0, 0, 0.5);
    }

    .modal .content {
        @apply mx-auto ;
    }
</style>

<script>
    export default {

        props: {
            contentClass: {
                type: String,
                default: null
            },
            disableClose: {
                type: Boolean,
                default: false
            },
            back: {
                type: Boolean,
                default: true
            }
        },

        data() {
            return {
                show: false,
                modalClass: 'content w-full md:w-2/3 lg:w-1/2 md:m-10 md:rounded md:shadow-lg overflow-hidden ' + this.contentClass
            }
        },

        mounted() {
            // this.back = !this.disableClose;
        },

        methods: {
            open() {
                this.show = true;
            },

            close() {
                this.$emit('close', true);
            }
        }

    }
</script>
